import { UpdateProduct } from '@/connection/content/products';
import { Product } from '@/types/module.types';
import { ContentReducerCreator } from '../types';

const updateProductReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async ({ channel, product }: { channel: number; product: Product }) => {
      return await UpdateProduct(channel, product);
    },
    {
      fulfilled: (state, action) => {
        if (state.products) {
          const newProduct = action.payload.products[0];
          state.products = state.products.map((product) =>
            product.product === newProduct.product ? newProduct : product
          );
        }
      },
    }
  );
};

export default updateProductReducer;
